import script from "./ViewAnAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAnAsset.vue?vue&type=script&setup=true&lang=js"

import "./ViewAnAsset.vue?vue&type=style&index=0&id=4875fe22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4875fe22"]])

export default __exports__